import styled from 'styled-components';
import { ThemeType } from '../../types/Theme';

const BannersCanvaContainer = styled.div<{theme: ThemeType}>`
    width: 100%;
    border-radius: 16px;
    padding: 16px;
    border: 1px solid ${({theme}) => theme.colors.elements};
    text-align: justify;
    .titulo{
        margin-bottom: 1rem;
        font-weight: 700;
    }
    .texto{
        margin-bottom: 1rem;
    }
    .links{
        text-align: left;
        a{
            margin: 0 1rem;
            text-decoration: underline;
        }
    }
`;

export { 
    BannersCanvaContainer,
};